//Remember last color used to prevent two consecutive boards with the same color
let lastBackground: string | undefined

let currentBoardId = "";

interface Actions {
  selectColorOld: (name: string, override?: boolean) => string
  selectColor: (name: string, boardId?: unknown) => { background: string; text: string }
}

interface ServiceInterface {
  actions: Actions
}

function useColorStore(): ServiceInterface {
  const actions = {
    /**
     * selectColor()
     * returns either a color or its complement by using the override value
     * @param name
     * @param override
     * @returns
     */
    selectColorOld(name: string, override = false): string {
      if (!name) return ''
      // note: this is supposed to work with names, not ids
      let value = name.length * 500

      for (let i = 0; i < value; i++) {
        const current = name.charCodeAt(i)
        // non ascii characters don't work for simplicity reasons
        if (current !== undefined && !isNaN(current)) value += current
      }

      const hue = value * 137.508 // use golden angle approximation
      return !override ? `hsl(${parseInt(hue.toString())},70%,50%);` : `hsl(${parseInt((hue * 137.508).toString())},10%,25%);`
    },

    selectColorOld2(str: string) {
      // Generate hash from string
      let hash = 0
      for (let i = 0; i < str.length; i++) {
        hash = ((hash << 5) - hash + str.charCodeAt(i)) & 0xffffffff
      }

      // Convert to HSL with high saturation and controlled lightness
      const hue = Math.abs(hash) % 360
      const saturation = 70 + (Math.abs(hash >> 8) % 30) // 70-100%
      const lightness = Math.abs(hash >> 16) % 2 === 0 ? 20 : 80 // Force light or dark

      const background = `hsl(${hue}, ${saturation}%, ${lightness}%)`
      const text = lightness > 50 ? '#000000' : '#ffffff'

      return { background, text }
    },

    //New setColor that remembers the previously used color. 
    // New selectColor that remembers the previously used color.
    selectColor(str: string, boardId?: unknown) {
      //console.log("Board ID is: ", boardId)
      const salt = boardId == null ? '' : String(boardId);
      const combined = salt ? `${str}|${salt}` : str;

      // 32-bit hash (same structure, but we’ll read via unsigned shifts)
      let hash = 0;
      for (let i = 0; i < combined.length; i++) {
        hash = ((hash << 5) - hash + combined.charCodeAt(i)) & 0xffffffff;
      }

      // Use unsigned shifts to avoid sign-extension bias
      let hue = (hash >>> 0) % 360;
      const saturation = 60 + ((hash >>> 10) % 30);   // 60–89%
      const lightness  = 30 + ((hash >>> 20) % 41);   // 30–70%

      let background = `hsl(${hue}, ${saturation}%, ${lightness}%)`;

      // Avoid repeating the exact last color
      const HUE_JITTER = 23;
      if (lastBackground === background) {
        hue = (hue + HUE_JITTER) % 360;
        background = `hsl(${hue}, ${saturation}%, ${lightness}%)`;
      }

      lastBackground = background;

      // Simple, robust contrast choice
      const text = lightness >= 50 ? '#000000' : '#ffffff';
      return { background, text };
    }

    //Todo - introduce more randomness (use boardID in additon to board name as an extra seed)



  }

  return { actions }
}

export default useColorStore


